import { ActionSetUser } from "./actions"

export const hasToken = ({ token }) => !!token && token != ''
export const hasAcesso = ({ acesso }) => !!acesso.grupo && acesso.grupo != null
export const menu = ({ menu }) => menu
export const user = ({ user }) => user
export const errorsHttp = ({ errorsHttp }) => errorsHttp